import menu from '../menu'

import inspire from '../webgl/inspire/inspire'
import InspireFiltering from './inspire-filters'
import scroll from '../animations/scroll/locomotiveScroll'


class ArchiveInspire extends InspireFiltering {
  constructor() {
    super()
    this.namespace = 'archive-inspire'
  }

  beforeLeave() {
    super.beforeLeave()
    inspire.fastLeave()
  }
}

export default new ArchiveInspire()
